import { bibleNames, resolveBookName } from "./main_script/bible_name";

function stripLegacyVersionSuffix(input: string): string {
	return input
		.replace(/;+\s*version\s*=\s*[^;]*;*/gi, "")
		.replace(/;+$/g, "")
		.trim();
}

export async function notfoundLogic() {
	const path = window.location.pathname;
	const hash = window.location.hash;
	const title = document.getElementById("title");

	if (path.startsWith("/commented_bible")) {
		// Get last path segment (may be "", "Psalms%206;version=160;", "1%20Chronicles%202.html", etc.)
		const lastSegment = path.split("/").filter(Boolean).slice(-1)[0] ?? "";

		const withoutExt = lastSegment.replace(/\.html$/i, "");
		const decoded = decodeURIComponent(decodeURIComponent(withoutExt));
		const cleaned = stripLegacyVersionSuffix(decoded);

		const target = resolveBookName(cleaned, bibleNames);

		// Avoid redirect loops: only redirect when we can actually change the URL.
		if (target && target !== decoded) {
			window.location.href = `/commented_bible/${target}.html${hash}`;
		}
		return;
	}

	if (title) {
		title.textContent = "Page Not Found";
		const textReport = document.getElementById("textReport");
		if (textReport) {
			textReport.style.display = "block";
		}
	}
}
